import Icon from './Icon';

const BlackPlay = (props) => (
  <Icon
    width="20px"
    height="20px"
    size="20px"
    viewBox="0 0 20 20"
    strokeWidth="1.5"
    stroke="#121212"
    color="#121212"
    {...props}
    path="M7.54408 16.1326L7.29307 15.4259L7.54408 16.1326C10.4141 15.1133 13.1038 13.6442 15.5126 11.7804C16.6769 10.8795 16.6769 9.12176 15.5126 8.22087C13.1038 6.35705 10.4141 4.88798 7.54408 3.86866L7.03345 3.6873C5.59306 3.17573 4.0902 4.15158 3.89776 5.61895C3.51976 8.50125 3.51976 11.5 3.89776 14.3823C4.0902 15.8497 5.59306 16.8256 7.03345 16.314L7.54408 16.1326Z"
  />
);

export default BlackPlay;
